<template>
  <div>
    <section class="dashboardFilterHeader">
      <router-link :to="goTo('charger_diagnostics')">
        <v-btn
          color="dark"
          text
          small
        >
          <!-- @click="redirectToParent" -->
          <v-icon> mdi-arrow-left </v-icon>
        </v-btn>
      </router-link>
    </section>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      no-filters
      @filterOption="onFiltersChange"
    >
      <template v-slot:id="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:status="{ item }">
        <div>
          <!-- Add a dot with dynamic color based on status -->
          <status-badge :status="item.status" />
        </div>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->

      <!-- Action Modals -->
      <!-- <template #actionModals>  </template> -->
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      filters: {},
      subFilters: {},

      headers: [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: "Diagnostic Code",
          align: "left",
          sortable: false,
          value: "VendorErrorCode",
        },
        {
          text: "Code Description",
          align: "left",
          sortable: false,
          value: "description",
        },
        {
          text: "Count",
          align: "left",
          sortable: false,
          value: "count",
        },
        // {
        //   text: this.$t("status"),
        //   align: "left",
        //   sortable: false,
        //   value: "status",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsChargingDiagnostics/getLoading",
      meta: "csmsChargingDiagnostics/getDetailMeta",
      list: "csmsChargingDiagnostics/getDetail",
    }),
    _headers() {
      // computed headers for showing columns to role based
      return this.headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      if (this.authUser.isAdmin) {
        return [];
      } else {
        return [];
      }
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},

  methods: {
    async fetchData() {
      const params = {
        // product: this.$route.query.product,
        // tenant_id: this.$route.query.tenant_id,
        // date: this.$route.query.date,
        // dateType: this.$route.query.dateType,
        ...this.$route.query,
      };

      if (params.dateType == "custom") {
        params.date = params.dateRange;
      }

      await this.$store
        .dispatch("csmsChargingDiagnostics/setDetail", params)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    },
    getStatusDotColor(status) {
      if (status.includes("green-dot")) return "dot-green";
      if (status.includes("red-dot")) return "dot-red";

      // Default behavior based on percentage
      const chargeValue = this.getChargeValue(status);
      return chargeValue >= 50 ? "dot-green" : "dot-red";
    },
    goTo(path) {
      const qry = this.$route.query;
      return { name: path, query: qry };
    },
  },
};
</script>
<style lang="sass" scoped>
.dashboardFilterHeader
  display: flex
  align-items: center
  padding: 6px 12px 0
  .headerBarWrap
    align-items: center
    padding: 0px 0

  :deep .filterBtn
    display: none !important
</style>
